import React, { useEffect, useState } from "react";
import Select from "react-select";

import { ResponsiveBar } from '@nivo/bar'
import { ResponsiveBump } from '@nivo/bump'
import { ResponsiveLine } from '@nivo/line'

import { ResponsivePie } from '@nivo/pie'


import "react-awesome-lightbox/build/style.css";
import { Modal, Col } from "react-bootstrap";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import moment from "moment"
/* Styles */
import 'react-multi-carousel/lib/styles.css';
import "../../../../../../styles/app/pages/CampaingPreview.scss";
import "./fix.css"

export function ExecutiveSummaryBar({ raw, total, mainTask, campaign, item: key, length }) {



    const [show, setShow] = useState(false);
    const _raw_base = [...raw].filter(row => row.task === mainTask);
    const data = []
    const pos_options = [...new Set(_raw_base.map(row => row.pos))]

    const col = length === key ? total % 2 !== 0 ? "col-12 p-2" : "col-6 p-2" : "col-6 p-2"
    return (
        <>
            <DetailsModal
                campaign={campaign}
                show={show}
                mainTask={mainTask}
                setShow={setShow}
                raw={_raw_base}
                onHide={() => setShow(false)}
                data={data}
            />
            <div className={col}>
                <div className="card text-center shadow-sm pointer-hover" style={{ height: "200px" }} onClick={() => setShow(true)}>
                    <br />
                    <h4 className="px-4 pt-4"><strong>{mainTask}</strong></h4>
                    <h6>Share of shelf</h6>

                    <div className="pb-4 text-center" style={{ height: "200px", width: "100%" }}>

                        <i class="fas fa-chart-pie fa-8x" style={{ color: "#8330C0" }}></i>
                    </div>

                </div>



            </div>


        </>
    );
}
export function DetailsModal({
    raw,
    show,
    onHide,
    no_percernt,
    yes_percernt,
    mainTask,
    setShow,
    campaign

}) {
    // const data_by_product = []


    const [index, setIndex] = useState("pos")
    const [_data, setData] = useState([])
    const [pos, setPOS] = useState(null)
    const [product, setProduct] = useState(null)
    const def = { label: "NONE", value: null }
    const pos_options = [...new Set(raw.map(row => row.pos))]
    const product_options = [...new Set(raw.map(row => row.product))]

    const [keys, setKeys] = useState(product_options)


    const select_pos = [def, ...pos_options.map(key => ({ label: key, value: key }))]
    const select_prd = [def, ...product_options.map(key => ({ label: key, value: key }))]
    function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    useEffect(() => {
        const data_by_pos = []

        product_options
            .filter(option => option === product || !product)
            .forEach(product => {
                const by_product = raw.filter(row => row.product === product).filter(row => row.pos === pos)
                const total = by_product.reduce((acc, row) => acc + row.quantity, 0)

                const document = {
                    id: product,
                    label: product,
                    color: getRandomColor(),
                    value: total

                }
                data_by_pos.push(document)
            })

        setData(data_by_pos)
    }, [pos, product])
    const _total = _data.reduce((acc, row) => acc + row.value, 0) || 1
    const data = _data.map(product => ({
        ...product,
        value: Number(((product.value / _total) * 100).toFixed(2))
    }))

    return (
        <Modal show={show}
            size="lg"
            closeButton
            dialogClassName="modal-90w"
        >
            <Modal.Header onHide={onHide} closeButton>
                <div className="row d-flex w-100 justify-content-between">
                    <div className="col-10">
                        <h1>Detalle, {mainTask}</h1>
                    </div>
                    <div className="col">
                        <div className="d-flex w-100 justify-content-end">
                            <span className="d-inline pointer-hover" onClick={() => {
                                setShow(false)
                            }}>
                                <i class="fas fa-times fa-2x" style={{ color: "#000" }}></i>
                            </span>
                        </div>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body>
                <div className="row p-2">
                <Col xs={12}><h5>*Debes seleccionar algun filtro para poder ver los datos.</h5></Col>

                    <Col xs={3}>
                        <label>Select POS</label>
                        <Select
                            options={select_pos}
                            onChange={(args) => {
                                setPOS(args.value)
                                // setIndex("pos")
                                // setKeys(pos_options)

                            }}
                        />
                    </Col>
                    {/* <Col xs={3}>
                        <label>Select Product</label>
                        <Select
                            options={select_prd}
                            onChange={(args) => {
                                setProduct(args.value)
                                // setIndex("product")
                                // setKeys(product_options)

                            }} />
                    </Col> */}
                    <Col xs={3}>
                        <br />

                        <button
                            className="btn btn-secondary mt-2"
                            onClick={() => {
                                setPOS(null)
                                setProduct(null)
                                setIndex("pos")
                                setKeys(product_options)

                            }} >
                            Reset
                        </button>
                    </Col>
                </div>


                <div className="pb-4" style={{ height: "600px", width: "100%" }}>
                    <ResponsivePie
                        data={data}
                        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                        activeOuterRadiusOffset={8}
                        borderWidth={1}
                        borderColor={{ from: 'color', modifiers: [['darker', '0']] }}
                        arcLinkLabelsSkipAngle={10}
                        arcLinkLabelsTextColor="#333333"
                        arcLinkLabelsThickness={2}
                        arcLinkLabelsColor={{ from: 'color' }}
                        arcLabelsRadiusOffset={0.8}
                        arcLabelsSkipAngle={10}
                        valueFormat={(item) => `${item}%`}

                        arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}

                    />
                </div>

            </Modal.Body>

        </Modal>
    )
}

